import React, { useState } from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import CloseIcon from "@mui/icons-material/Close";

import "./Footer.css";
import FooterLogo from "../../Assets/Images/logo.svg";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import LocationIcon from "../../Assets/Images/Icons/LocateUsOnMap.webp";
import WhatsAppIcon from "../../Assets/Images/Icons/ConnectUsonWhatsapp.webp";
import iso1 from "../../Assets/Images/iso1.png";
import iso2 from "../../Assets/Images/iso2.png";
import ssl from "../../Assets/Images/ssl.png";
import iso9001 from "../../Assets/Images/ISO 9001_DWEBBOX IT SOLUTIONS PRIVATE LIMITED.webp";
import iso27001 from "../../Assets/Images/ISO 27001_DWEBBOX IT SOLUTIONS PRIVATE LIMITED.webp";

function Footer() {
  const [imageModal, setImageModal] = useState({ open: false, src: "" });

  const openImageModal = (src) => {
    setImageModal({ open: true, src });
  };

  const closeImageModal = () => {
    setImageModal({ open: false, src: "" });
  };

  return (
    <div className="Footer">
      <div className="Footer-list-content">
        <div className="Footer-logo">
          <img src={FooterLogo} alt="" />

          <div className="iso-certificates">
            <img
              src={iso1}
              alt="ISO 1"
              className="iso-img iso1"
              onClick={() => openImageModal(iso9001)}
            />
            <img
              src={iso2}
              alt="ISO 2"
              className="iso-img iso2"
              onClick={() => openImageModal(iso27001)}
            />
            <img src={ssl} alt="SSL" className="iso-img iso-ssl" />
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-social-icons">
            <div className="social-heading">
              <h3>Social</h3>
            </div>
            <div className="social-links">
              <p>
                {" "}
                <a
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontFamily: "DM Sans18ptLight",
                  }}
                  href="https://www.linkedin.com/company/d-webbox/mycompany/"
                  target="_blank"
                >
                  LINKEDIN
                </a>{" "}
              </p>
              <p>
                {" "}
                <a
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontFamily: "DM Sans18ptLight",
                  }}
                  href="https://www.instagram.com/dwebbox/"
                  target="_blank"
                >
                  {" "}
                  INSTAGRAM
                </a>
              </p>
              <p>
                {" "}
                <a
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontFamily: "DM Sans18ptLight",
                  }}
                  href="https://www.facebook.com/p/DWebBox-100054804518286/"
                  target="_blank"
                >
                  FACEBOOK
                </a>
              </p>
              {/* <p> <a style={{textDecoration:"none",color:"white",fontFamily:"DM Sans18ptLight"}}  href="" target="_blank" > UPWORK</a></p> */}
            </div>
          </div>
          <div className="footer-Address">
            <h3 className="address-heading">Address</h3>
            <p className="address-paragraph">
              70, Ratnajyot Industrial Estate, 2nd Floor, Irla Lane, Vile Parle
              (W), Mumbai, Maharashtra 400056
            </p>
            <div className="LocationIcon-img">
              <a
                href="https://maps.app.goo.gl/n9aFxEwFiNineENu7"
                target="_blank"
              >
                <img src={LocationIcon} alt="" width="50%" />
              </a>
            </div>
          </div>
          <div className="Footer-Contact-information-number">
            <div className="social-heading">
              <h3 style={{ color: "#ffffff" }}>Contact</h3>
            </div>
            <div className="mobile-number-section-main">
              <p className="mobile-number">
                <a href="tel:+918828103808">+91 8828103808</a>
              </p>
              <p className="mobile-number-second">
                <a href="tel:9167871033">+91 9167871033</a>
              </p>
              <p className="mobile-number-second">
                <a href="tel:8484946567">+91 8484946567</a>
              </p>
            </div>

            <div className="WhatsAppIcon-FooterImg">
              <a
                href="https://api.whatsapp.com/send?phone=+918828103808&text=Hello"
                target="_blank"
              >
                <img src={WhatsAppIcon} alt="" width="50%" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="connect-dewebbox">
        <div className="collab-section">
          <h2>Let's collaborate.</h2>
          <div className="arrow-heading">
            <h1>
              <a href="mailto:connect@dwebbox.com">connect@dwebbox.com</a>
            </h1>
            <ArrowOutwardIcon
              className="arrow-outward-icon"
              sx={{
                color: "white",
                fontSize: "50px",
                fontWeight: "700",
                marginTop: "5px",
              }}
            />
          </div>
        </div>
        <h3> Recognised Startup by DPIIT,<span className="mobile-break">  Government of India</span></h3>
      </div>

      <div className="straight-line-footer"></div>

      <div className="footer-para">
        <p>
          © 2026 D-WEBBOX IT SOLUTIONS Pvt. Ltd.{" "}
          <span className="footer-span">All rights reserved. </span>{" "}
        </p>
      </div>

      {imageModal.open && (
        <div className="testimonial-modal-overlay" onClick={closeImageModal}>
          <div
            className="testimonial-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-modal-btn" onClick={closeImageModal}>
              <CloseIcon />
            </button>
            <Zoom>
              <img
                src={imageModal.src}
                alt="Certificate"
                className="full-testimonial-image"
              />
            </Zoom>
          </div>
        </div>
      )}
    </div>
  );
}

export default Footer;
